import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"
import _imports_0 from '../../assets/svg/logo-color.svg'


const _hoisted_1 = {
  id: "sign-up-container",
  class: "row"
}
const _hoisted_2 = { class: "col-xl-lg-md-sm-xs-12 sign-up-panel" }
const _hoisted_3 = { class: "heading" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h3", null, "Registration", -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" back to login ")
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "panel-body" }
const _hoisted_9 = { class: "legend-border" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("legend", { class: "legend-border" }, "FIRST NAME", -1)
const _hoisted_11 = { class: "legend-border" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("legend", { class: "legend-border" }, "LAST NAME", -1)
const _hoisted_13 = { class: "legend-border" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("legend", { class: "legend-border" }, "EMAIL ADDRESS", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("ul", null, [
    /*#__PURE__*/_createElementVNode("li", { class: "warning" }, "After sign up, you will not be able to change the email address associated with your account. Be sure to sign up with an email address that you will have long-term access to.")
  ])
], -1)
const _hoisted_16 = { class: "row" }
const _hoisted_17 = { class: "col-sm-6 left-cell hidden-xs" }
const _hoisted_18 = { class: "legend-border" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("legend", { class: "legend-border" }, "GENDER", -1)
const _hoisted_20 = { class: "w100" }
const _hoisted_21 = { class: "col-sm-6 right-cell hidden-xs" }
const _hoisted_22 = { class: "legend-border" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("legend", { class: "legend-border" }, "CAPACITY", -1)
const _hoisted_24 = { class: "w100" }
const _hoisted_25 = { class: "legend-border" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("legend", { class: "legend-border" }, "AFFILIATION", -1)
const _hoisted_27 = { class: "w100" }
const _hoisted_28 = { class: "legend-border" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("legend", { class: "legend-border" }, "ORGANIZATION", -1)
const _hoisted_30 = { class: "legend-border" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("legend", { class: "legend-border" }, "COUNTRY", -1)
const _hoisted_32 = { class: "w100" }
const _hoisted_33 = { class: "legend-border" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("legend", { class: "legend-border" }, "PASSWORD", -1)
const _hoisted_35 = { class: "input-group" }
const _hoisted_36 = { class: "legend-border" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("legend", { class: "legend-border" }, "CONFIRM PASSWORD", -1)
const _hoisted_38 = { class: "input-group" }
const _hoisted_39 = ["hidden"]
const _hoisted_40 = { class: "footer" }
const _hoisted_41 = ["disabled"]
const _hoisted_42 = /*#__PURE__*/_createTextVNode(" Sign Up ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Input = _resolveComponent("Input")!
  const _component_CaretDownFilled = _resolveComponent("CaretDownFilled")!
  const _component_Option = _resolveComponent("Option")!
  const _component_Select = _resolveComponent("Select")!
  const _component_Password = _resolveComponent("Password")!
  const _component_Spin = _resolveComponent("Spin")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _hoisted_5,
        (!_ctx.disabled)
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 0,
              id: "login-link",
              to: _ctx.loginLocation
            }, {
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 1
            }, 8, ["to"]))
          : _createCommentVNode("", true),
        (_ctx.disabled)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, "back to login"))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("form", {
            onSubmit: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)), ["prevent"]))
          }, [
            _createElementVNode("fieldset", _hoisted_9, [
              _hoisted_10,
              _createVNode(_component_Input, {
                ref: "firstName",
                value: _ctx.form.firstName,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.firstName) = $event)),
                "data-cy": "firstName",
                type: "text",
                class: "form-control",
                placeholder: "First name *",
                required: "",
                autocomplete: "off"
              }, null, 8, ["value"])
            ]),
            _createElementVNode("fieldset", _hoisted_11, [
              _hoisted_12,
              _createVNode(_component_Input, {
                ref: "lastName",
                value: _ctx.form.lastName,
                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.lastName) = $event)),
                "data-cy": "lastName",
                type: "text",
                class: "form-control",
                placeholder: "Last name *",
                required: "",
                autocomplete: "off"
              }, null, 8, ["value"])
            ]),
            _createElementVNode("fieldset", _hoisted_13, [
              _hoisted_14,
              _createVNode(_component_Input, {
                ref: "email",
                value: _ctx.form.email,
                "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.email) = $event)),
                "data-cy": "email",
                type: "email",
                class: "form-control shadow-none",
                placeholder: "Email address *",
                required: "",
                autocomplete: "off"
              }, null, 8, ["value"]),
              _hoisted_15
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("fieldset", _hoisted_18, [
                  _hoisted_19,
                  _createElementVNode("div", _hoisted_20, [
                    _createVNode(_component_Select, {
                      placeholder: "Select a Gender *",
                      value: _ctx.selectedGender,
                      "get-popup-container": (triggerNode) => triggerNode.parentNode,
                      onChange: _ctx.setGender
                    }, {
                      suffixIcon: _withCtx(() => [
                        _createVNode(_component_CaretDownFilled, { style: {"color":"black"} })
                      ]),
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.genderArray, (genderOption, index) => {
                          return (_openBlock(), _createBlock(_component_Option, {
                            key: index,
                            value: index
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(genderOption), 1)
                            ]),
                            _: 2
                          }, 1032, ["value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["value", "get-popup-container", "onChange"])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("fieldset", _hoisted_22, [
                  _hoisted_23,
                  _createElementVNode("div", _hoisted_24, [
                    _createVNode(_component_Select, {
                      placeholder: "Select a Capacity *",
                      value: _ctx.selectedCapacity,
                      "get-popup-container": (triggerNode) => triggerNode.parentNode,
                      onChange: _ctx.setCapacity
                    }, {
                      suffixIcon: _withCtx(() => [
                        _createVNode(_component_CaretDownFilled, { style: {"color":"black"} })
                      ]),
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.capacityArray, (capacity, index) => {
                          return (_openBlock(), _createBlock(_component_Option, {
                            key: index,
                            value: index
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(capacity), 1)
                            ]),
                            _: 2
                          }, 1032, ["value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["value", "get-popup-container", "onChange"])
                  ])
                ])
              ])
            ]),
            _createElementVNode("fieldset", _hoisted_25, [
              _hoisted_26,
              _createElementVNode("div", _hoisted_27, [
                _createVNode(_component_Select, {
                  placeholder: "Select an Affiliation *",
                  value: _ctx.selectedAffiliation,
                  "get-popup-container": (triggerNode) => triggerNode.parentNode,
                  onChange: _ctx.setAffiliation
                }, {
                  suffixIcon: _withCtx(() => [
                    _createVNode(_component_CaretDownFilled, { style: {"color":"black"} })
                  ]),
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.affiliationArray, (affiliation, index) => {
                      return (_openBlock(), _createBlock(_component_Option, {
                        key: index,
                        value: index
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(affiliation), 1)
                        ]),
                        _: 2
                      }, 1032, ["value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["value", "get-popup-container", "onChange"])
              ])
            ]),
            _createElementVNode("fieldset", _hoisted_28, [
              _hoisted_29,
              _createVNode(_component_Input, {
                ref: "organization",
                value: _ctx.form.organization,
                "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.organization) = $event)),
                "data-cy": "organization",
                type: "text",
                class: "form-control",
                placeholder: "Organization *",
                autocomplete: "off"
              }, null, 8, ["value"])
            ]),
            _createElementVNode("fieldset", _hoisted_30, [
              _hoisted_31,
              _createElementVNode("div", _hoisted_32, [
                _createVNode(_component_Select, {
                  "show-search": "",
                  placeholder: "Select a Country *",
                  value: _ctx.selectedCountry,
                  "get-popup-container": (triggerNode) => triggerNode.parentNode,
                  onChange: _ctx.setCountry
                }, {
                  suffixIcon: _withCtx(() => [
                    _createVNode(_component_CaretDownFilled, { style: {"color":"black"} })
                  ]),
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.countryArray, (country, index) => {
                      return (_openBlock(), _createBlock(_component_Option, {
                        key: index,
                        value: country.name
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(country.name), 1)
                        ]),
                        _: 2
                      }, 1032, ["value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["value", "get-popup-container", "onChange"])
              ])
            ]),
            _createElementVNode("fieldset", _hoisted_33, [
              _hoisted_34,
              _createElementVNode("div", _hoisted_35, [
                _createVNode(_component_Password, {
                  value: _ctx.form.password,
                  "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.password) = $event)),
                  "data-cy": "password",
                  type: _ctx.passwordFieldType,
                  class: "form-control",
                  placeholder: "Password *",
                  autocomplete: "off",
                  required: "",
                  pattern: "(?=.*\\d)(?=.*[a-z])(?=.*[A-Z]).{8,}"
                }, null, 8, ["value", "type"])
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("ul", null, [
                  _createElementVNode("li", {
                    class: _normalizeClass(_ctx.containsLetter)
                  }, "Must contain at least one letter", 2),
                  _createElementVNode("li", {
                    class: _normalizeClass(_ctx.containsCapital)
                  }, "Must contain at least one upper case letter", 2),
                  _createElementVNode("li", {
                    class: _normalizeClass(_ctx.containsLowercase)
                  }, "Must contain at least one lower case letter", 2),
                  _createElementVNode("li", {
                    class: _normalizeClass(_ctx.containsNumber)
                  }, "Must contain at least one number", 2),
                  _createElementVNode("li", {
                    class: _normalizeClass(_ctx.containsSpecialCharacter)
                  }, " Must contain at least one special character (?-_*) ", 2),
                  _createElementVNode("li", {
                    class: _normalizeClass(_ctx.longEnough)
                  }, "Must be at least 8 characters long", 2)
                ])
              ])
            ]),
            _createElementVNode("fieldset", _hoisted_36, [
              _hoisted_37,
              _createElementVNode("div", _hoisted_38, [
                _createVNode(_component_Password, {
                  value: _ctx.form.confirmPassword,
                  "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.confirmPassword) = $event)),
                  "data-cy": "confirmPassword",
                  type: _ctx.passwordFieldType,
                  class: "form-control",
                  placeholder: "Confirm Password *",
                  required: "",
                  pattern: "(?=.*\\d)(?=.*[a-z])(?=.*[A-Z]).{8,}",
                  autocomplete: "off"
                }, null, 8, ["value", "type"])
              ]),
              _createElementVNode("div", {
                class: "error",
                hidden: _ctx.passwordFieldsMatch
              }, "Both password fields must match", 8, _hoisted_39)
            ]),
            _createElementVNode("div", _hoisted_40, [
              _createElementVNode("button", {
                id: "sign-up-button",
                disabled: _ctx.disabled,
                type: "submit",
                class: "btn-primary-submit orange"
              }, [
                _hoisted_42,
                _createVNode(_component_Spin, { state: _ctx.disabled }, null, 8, ["state"])
              ], 8, _hoisted_41)
            ])
          ], 32)
        ])
      ])
    ])
  ]))
}